// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class I64 implements flatbuffers.IUnpackableObject<I64T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): I64 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsI64(bb: flatbuffers.ByteBuffer, obj?: I64): I64 {
    return (obj || new I64()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsI64(bb: flatbuffers.ByteBuffer, obj?: I64): I64 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new I64()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startI64(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(0, value, 0n);
  }

  static endI64(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createI64(builder: flatbuffers.Builder, value: bigint): flatbuffers.Offset {
    I64.startI64(builder);
    I64.addValue(builder, value);
    return I64.endI64(builder);
  }

  unpack(): I64T {
    return new I64T(this.value());
  }

  unpackTo(_o: I64T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): I64T {
    const t = new I64T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class I64T implements flatbuffers.IGeneratedObject {
  constructor(public value: bigint = 0n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return I64.createI64(builder, this.value);
  }

  clone(): I64T {
    const obj = new I64T();
    obj.value = this.value;
    return obj;
  }

  equals(other: I64T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyI64(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
